import _sfc_main from './speak-content.vue2.js';
/* empty css                  */
import _export_sfc from '../../../_virtual/_plugin-vue_export-helper.js';

const SpeakContent = /* @__PURE__ */ _export_sfc(_sfc_main, [["__scopeId", "data-v-976ee23a"]]);

export { SpeakContent as default };
//# sourceMappingURL=speak-content.js.map
